<template>
  <div @close="handleClose" class="video-modal" @click="handleClose">
    <!-- a button to close the modal -->
    <button class="close-button" @click="handleClose" aria-labelledby="closeLabel">
      <span id="closeLabel" class="screen-reader-text">Close Overlay</span>
      <span aria-hidden="true" class="close-button__icon">&times;</span>
    </button>
    <media-video :video-link="videoLink" v-if="isExternal" />
    <video controls width="100%" height="100%" v-else-if="videoLink">
      <source :src="videoLink" />
    </video>
  </div>
</template>

<script>
export default {
  name: "ModalVideo",
  props: {
    videoLink: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
  computed: {
    isExternal() {
      return (
        this.videoLink.indexOf("youtu") >= 0 ||
        this.videoLink.indexOf("vimeo") >= 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// position the button in the top right corner of the window
.close-button {
  border: none;
  border-radius: 100%;
  cursor: pointer;
  font-size: 1.5rem;
  inset: -10px -10px auto auto;
  line-height: 1;
  padding: 5px 11px 7px;
  position: absolute;
  z-index: 102; 
}
.video-modal {
  box-sizing: border-box;
  height: 80vh;
  left: 10vw;
  position: fixed;
  top: 10vh;
  width: 80vw;
  z-index: 100;

  /deep/ div {
    height: 100%;
    margin: 0;
  }
  video {
    position: relative;
    z-index: 101;
  }

  &:before {
    background: rgba(0, 0, 0, 0.75);
    content: "";
    height: 100vh;
    inset: 0;
    position: fixed;
    width: 100vw;
  }
}
</style>
